import { compose, head, split } from 'ramda';

export const getCurrentUrlWithoutQueryParams = () =>
	compose<[string], string[], string>(head, split('?'))(window.location.href);
